export default (node) => {
  /**
   * Data + elements
   */
  const variantButtons = node.querySelectorAll('[data-product-variant-button]');

  /**
   * Functions
   */
  const handleOptionVariantClick = (e) => {
    variantButtons.forEach((button) => {
      button.dataset.productVariantButton = 'false';
      button.classList.remove('image-selected', 'bg-gray-10');
      const mark = button.querySelector('[data-product-variant-button-mark]');
      if (mark) {
        mark.classList.add('hidden');
      }
    });

    let currentTargetElement = null
    if (e.currentTarget) {
      currentTargetElement = e.currentTarget;
    } else {
      currentTargetElement = e;
    }

    currentTargetElement.dataset.productVariantButton = 'true';
    currentTargetElement.classList.add('image-selected', 'bg-gray-10');
    const mark = currentTargetElement.querySelector(
      '[data-product-variant-button-mark]'
    );
    if (mark) {
      mark.classList.remove('hidden');
    }

    const optionName = currentTargetElement.dataset.productVariantOptionName;

    if (optionName) {
      const optionValue = currentTargetElement.dataset.productVariantOptionValue;
      const optionContainer = document.querySelector(
        `[data-product-option-name="${optionName}"]`
      );
      optionContainer.textContent = optionValue;
    }
  };

  /**
   * Init
   */
  const init = () => {
    variantButtons.forEach((button) => {
      button.addEventListener('click', handleOptionVariantClick);
    });

    document.addEventListener('manualVariantSelected', (e) => {
      const temp = e.detail.element;
      handleOptionVariantClick(temp);
    });
  };

  init();
};
